import { RATING_OPTS } from "./trainingReviewQueueShared";

type Props = {
  mGrounding: number;
  setMGrounding: (n: number) => void;
  mTone: number;
  setMTone: (n: number) => void;
  mAccuracy: number;
  setMAccuracy: (n: number) => void;
  lClarity: number;
  setLClarity: (n: number) => void;
  lAnswersCustomer: number;
  setLAnswersCustomer: (n: number) => void;
  lFollowUpQuestions: number;
  setLFollowUpQuestions: (n: number) => void;
  lOpenEndedQuestions: number;
  setLOpenEndedQuestions: (n: number) => void;
};

export function TrainingReviewRubricGrid({
  mGrounding,
  setMGrounding,
  mTone,
  setMTone,
  mAccuracy,
  setMAccuracy,
  lClarity,
  setLClarity,
  lAnswersCustomer,
  setLAnswersCustomer,
  lFollowUpQuestions,
  setLFollowUpQuestions,
  lOpenEndedQuestions,
  setLOpenEndedQuestions,
}: Props) {
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <div className="space-y-2">
        <div className="text-xs font-semibold text-gray-800 uppercase tracking-wide">AI customer</div>
        <label className="block text-xs text-gray-700">
          Grounding (KB use)
          <select
            className="mt-0.5 w-full rounded-lg border border-gray-200 text-sm px-2 py-1"
            value={mGrounding}
            onChange={(e) => setMGrounding(Number(e.target.value))}
          >
            {RATING_OPTS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
        <label className="block text-xs text-gray-700">
          Tone
          <select
            className="mt-0.5 w-full rounded-lg border border-gray-200 text-sm px-2 py-1"
            value={mTone}
            onChange={(e) => setMTone(Number(e.target.value))}
          >
            {RATING_OPTS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
        <label className="block text-xs text-gray-700">
          Accuracy vs facts
          <select
            className="mt-0.5 w-full rounded-lg border border-gray-200 text-sm px-2 py-1"
            value={mAccuracy}
            onChange={(e) => setMAccuracy(Number(e.target.value))}
          >
            {RATING_OPTS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className="space-y-2">
        <div className="text-xs font-semibold text-gray-800 uppercase tracking-wide">Trainee</div>
        <label className="block text-xs text-gray-700">
          Clarity
          <select
            className="mt-0.5 w-full rounded-lg border border-gray-200 text-sm px-2 py-1"
            value={lClarity}
            onChange={(e) => setLClarity(Number(e.target.value))}
          >
            {RATING_OPTS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
        <label className="block text-xs text-gray-700">
          Answers customer questions
          <select
            className="mt-0.5 w-full rounded-lg border border-gray-200 text-sm px-2 py-1"
            value={lAnswersCustomer}
            onChange={(e) => setLAnswersCustomer(Number(e.target.value))}
          >
            {RATING_OPTS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
        <label className="block text-xs text-gray-700">
          Uses follow-up questions
          <select
            className="mt-0.5 w-full rounded-lg border border-gray-200 text-sm px-2 py-1"
            value={lFollowUpQuestions}
            onChange={(e) => setLFollowUpQuestions(Number(e.target.value))}
          >
            {RATING_OPTS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
        <label className="block text-xs text-gray-700">
          Uses open-ended questions
          <select
            className="mt-0.5 w-full rounded-lg border border-gray-200 text-sm px-2 py-1"
            value={lOpenEndedQuestions}
            onChange={(e) => setLOpenEndedQuestions(Number(e.target.value))}
          >
            {RATING_OPTS.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
}
